import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
	name: "imdex-app-layout"
};

import AppLayoutDefault from "./AppLayoutDefault.vue";
import { markRaw, ref, watch } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const layout = ref();
const route = useRoute();

watch(
	() => route.meta?.layout as string | undefined,
	async (metaLayout) => {
		try {
			const component =
				metaLayout && (await import(/* @vite-ignore */ `./${metaLayout}.vue`));
			layout.value = markRaw(component?.default || AppLayoutDefault);
		} catch (e) {
			layout.value = markRaw(AppLayoutDefault);
		}
	},
	{ immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})